import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { TrendLabel } from '@/api/rest/resources/conservation';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import {
  NdviChartData,
  NDVIHistoricalChart,
} from '@/pages/shared/projects/pages/project/pages/conservation/BU/components/Charts/NDVIHistorical';
import { useGetTrendLabel } from '@/pages/shared/projects/pages/project/pages/conservation/BU/hooks/useGetTrendLabel';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

export const GraphTile = () => {
  const { t } = useTranslation();

  const trendLabel = useGetTrendLabel({
    trendChangeFact: 'r1_conservation_ndvi_change_percentage',
  });

  const ndviTimeSeries = useFact<{ value: Record<string, number> }>('r1_conservation_ndvi_ts');
  const baselineYear = useFact<number>('r1_conservation_ndvi_baseline_year').value;

  const chartData: NdviChartData[] = Object.entries(ndviTimeSeries.value).map(([year, value]) => {
    const ndviValue = typeof value === 'number' ? value : 0;

    return {
      ndviBar: ndviValue,
      ndviLine: ndviValue,
      date: new Date(year),
    };
  });

  return (
    <Stack center spacing={6} data-testid='ndvi-graph-tile'>
      <ChartHeading
        heading={t('shared.ncaDetail.details.landMonitoring.ndvi.evolution.chartHeading', { year: baselineYear })}
        className='w-full px-6 sm:px-0'
      />
      <NDVIHistoricalChart data={chartData} trendLabel={trendLabel === TrendLabel.stable ? null : trendLabel} />{' '}
      {/* TODO: science has to decide what "stable" means for NDVI */}
    </Stack>
  );
};
